import React from 'react';
import { MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo-center">
            <img 
              src="/logo.png" 
              alt="1stHand Consultancy Ltd Logo" 
              className="footer-company-logo"
            />
          </div>
          
          <div className="footer-company-info">
            <div className="footer-address">
              61 Bridge Street, Kington, HR5 3DJ, United Kingdom
            </div>
            <div className="footer-registration">
              UK Company House Registration Number is {companyInfo.companyNo}
            </div>
            <div className="footer-vat">
              VAT Number is {companyInfo.vatNo}
            </div>
          </div>
          
          <div className="footer-services">
            <div className="footer-services-row">
              <div className="footer-services-column">
                <h4 className="footer-heading">Network Services</h4>
                <ul className="footer-list">
                  <li>Custom Network Design</li>
                  <li>Complex Project Delivery</li>
                  <li>Network Troubleshooting</li>
                  <li>Monitoring & Support</li>
                </ul>
              </div>
              
              <div className="footer-services-column">
                <h4 className="footer-heading">Security Services</h4>
                <ul className="footer-list">
                  <li>Architectural Assessment</li>
                  <li>Security Controls</li>
                  <li>Risk Assessments</li>
                  <li>Security Audits</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 {companyInfo.name}. All rights reserved.</p>
            <div className="footer-slogan-bottom">
              <span className="footer-slogan-protect">Protect</span>
              <span className="footer-slogan-trust">Trust</span>
              <span className="footer-slogan-innovate">Innovate</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;